import {RootState} from "../store";

export const selectTransactioWorkflow = (state: RootState) => state.transaction.workflow;
export const selectTransactionList = (state: RootState) => state.transaction.listing;
export const selectTransactionDetail = (state: RootState) => state.transaction.detail;
